import type { IconSvgObject } from './types';

const SquareParkingOffIcon: IconSvgObject = [
  ["path", { d: "M3.08576 3.08579C2.72383 3.44772 2.49997 3.94772 2.49997 4.5V19.5C2.49997 20.6046 3.3954 21.5 4.49997 21.5H19.5C20.0523 21.5 20.5523 21.2761 20.9142 20.9142M7.49997 2.5H19.5C20.6045 2.5 21.5 3.39543 21.5 4.5V16.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M8.5 8.5V12.5M8.5 12.5V17.5M8.5 12.5H12.5M11.5 6.5H12.5C14.1569 6.5 15.5 7.84315 15.5 9.5C15.5 9.80309 15.4551 10.0957 15.3715 10.3715", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M2 2L22 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default SquareParkingOffIcon;
